import { render, staticRenderFns } from "./PresetFiltersItem.vue?vue&type=template&id=f1b58908&scoped=true"
import script from "./PresetFiltersItem.vue?vue&type=script&lang=js"
export * from "./PresetFiltersItem.vue?vue&type=script&lang=js"
import style0 from "./PresetFiltersItem.vue?vue&type=style&index=0&id=f1b58908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b58908",
  null
  
)

export default component.exports